// Reuse the installed Metrika counter. Never send form values or raw error messages.
export const AUTH_COUNTER = 42914764;
const FORMS = ['signup', 'signin', 'activation'];
const SURFACES = ['page', 'homepage'];
export function authFailure(form, error, validation = false) {
  if (validation) return 'validation';
  const status = Number(error?.statusCode || error?.status || error?.data?.statusCode || 0);
  if (status === 429) return 'rate_limited';
  if (status === 403) return 'access_denied';
  if (status === 409) return 'account_exists';
  if (status === 412) return 'email_unconfirmed';
  if (status === 401) return form === 'signin' ? 'invalid_credentials' : 'unauthorized';
  if (status === 400 || status === 422) return form === 'activation' ? 'invalid_link_or_password' : 'invalid_data';
  return status >= 500 ? 'server_error' : 'network_or_unknown';
}

export function createAuthFlow(form, {send, surface = 'page'} = {}) {
  if (!FORMS.includes(form)) throw new Error('Unknown auth form');
  let viewed = false, invalidSent = false, method = 'manual';
  const emit = (target, extra = {}, wait = false) => {
    try { return Promise.resolve(send(target, {auth_funnel: {version: '1', form,
      surface: SURFACES.includes(surface) ? surface : 'page', method, ...extra}}, wait)).catch(() => false); }
    catch { return Promise.resolve(false); }
  };
  const view = () => { if (!viewed) { viewed = true; void emit(`auth:${form}_view`); } };
  return {
    view,
    attempt(nextMethod = 'manual') { view(); invalidSent = false; method = nextMethod === 'credential' ? 'credential' : 'manual'; void emit(`auth:${form}_attempt`); },
    invalid() { view(); if (!invalidSent) { invalidSent = true; void emit(`auth:${form}_error`, {reason: 'validation'}); } },
    failure(error) { return emit(`auth:${form}_error`, {reason: authFailure(form, error)}); },
    success() { return emit(form === 'activation' ? 'auth:activate' : `auth:${form}`, {}, true); },
  };
}

// Bounded delivery before redirect; a missing/blocked counter never blocks authentication.
export function createAuthSender({getWindow = () => window, now = () => Date.now(), delay = ms => new Promise(r => setTimeout(r, ms))} = {}) {
  let queue = Promise.resolve();
  return (target, parameters, wait = false) => {
    const started = now();
    const task = queue.then(async () => {
      const w = getWindow();
      if (!w || w.location?.hostname !== 'uogorod.ru' || w.disableYaCounter42914764
        || /(?:^|;\s*)uo_analytics_excluded=1(?:;|$)/.test(w.document?.cookie || '')
        || w.navigator?.doNotTrack === '1' || w.doNotTrack === '1' || w.navigator?.globalPrivacyControl === true) return false;
      while (typeof w.ym !== 'function' && now() - started < 700) {
        await delay(35);
        if (w.disableYaCounter42914764) return false;
      }
      if (typeof w.ym !== 'function' || w.disableYaCounter42914764) return false;
      if (!wait) { w.ym(AUTH_COUNTER, 'reachGoal', target, parameters); return true; }
      return new Promise(resolve => {
        const timer = setTimeout(() => resolve(false), 250);
        try { w.ym(AUTH_COUNTER, 'reachGoal', target, parameters, () => { clearTimeout(timer); resolve(true); }); }
        catch { clearTimeout(timer); resolve(false); }
      });
    }).catch(() => false);
    queue = task;
    return task;
  };
}
let browserSender;
export function authFlow(form, options = {}) {
  if (typeof window === 'undefined') return createAuthFlow(form, {...options, send: () => false});
  browserSender ||= createAuthSender();
  return createAuthFlow(form, {...options, send: browserSender});
}
